import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class GraylogNotificationConfigurationService {

  constructor(private dataService: DataService) { }

  GraylogNotificationConfiguration() {
    return this.dataService.getRecord('/api/GraylogNotificationConfiguration/GetGraylogNotificationConfiguration');
  };
  saveGraylogConfiguration(data: any) {
    return this.dataService.post('/api/GraylogNotificationConfiguration/SaveGraylogConfiguration', data);
  }
}
